export const formatTimeHHMMSS = (seconds: number) => {
  const hrs = Math.floor(seconds / 3600).toString().padStart(2, '0');
  const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');
  return `${ hrs }:${ mins }:${ secs }`;
}

export const formatTimeMMSS = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${ minutes }:${ remainingSeconds < 10 ? "0" : "" }${ remainingSeconds }`;
};